import icons from "../../img/icon/icons";
import styles from "./PurchaseHistoryItem.module.css";
import { getFormattedNumberStr } from "../common/Common";
import { PurchaseHistoryItem as PurchaseHistoryItemType, PurchaseInfo } from "./PurchaseHistory";
import { useModal } from "../modal/Modal";
import ModalButtons from "../modal/ModalButtons";

interface PurchaseHistoryItemProps {
    data: PurchaseHistoryItemType;
    onRefundClick: (purchaseInfo: PurchaseInfo) => void;
}

const PurchaseHistoryItem = ({ data, ...props }: PurchaseHistoryItemProps) => {
    const { ModalComponent, openModal, closeModal } = useModal();

    const onRefundClick = () => {
        openModal({
            title: "안내",
            children: "정말 구독 취소 및 환불하시겠습니까?",
            modalButtons: (
                <ModalButtons
                    buttonCount={2}
                    buttons={[
                        {
                            label: "취소",
                            color: "Secondary",
                            onClick: () => {
                                closeModal();
                            },
                        },
                        {
                            label: "구독 취소 및 환불",
                            color: "Danger",
                            onClick: () => {
                                props.onRefundClick(data);
                                closeModal();
                            },
                        },
                    ]}
                />
            ),
        });
    };

    // 구매내역 환불상태 정규화
    const status = Number(String(data.refundStatus ?? 0).trim()); // 0|1|2 로 강제
    const now = new Date();
    const exp = data.expireDate ? new Date(data.expireDate) : undefined;
    const isExpired = exp ? exp < now : false;

    return (
        <>
            <div className={styles.container}>
                <img className={styles.icon} src={icons["logoM"]} alt="logo" />
                <div className={styles.content}>
                    <div className={styles.title}>{`모두의지도 ${data.gradeName}`}</div>
                    <div className={styles.date}>{`${data.purchaseDate.split(" ")[0]}~${data.expireDate}(1개월)`}</div>
                </div>
                <div>{`₩${getFormattedNumberStr(data.price)}`}</div>
                {/* 지나간 달도 환불 완료 보이도록 수정 | smyun | 250905 */}
                {status === 2 ? (
                    // ✅ 환불 완료
                    <div className={isExpired ? styles.disabledText : styles.date}>환불 완료</div>
                ) : status === 1 ? (
                    // ✅ 환불 접수 중
                    <div className={styles.date}>환불 접수 중</div>
                ) : isExpired ? (
                    // ✅ 유효기간 만료 → 환불 버튼 비활성
                    <div className={styles.disabledText}>
                        구독 취소 및 <br /> 환불 요청
                    </div>
                ) : (
                    // ✅ 환불 요청 버튼
                    <div className={styles.button} onClick={onRefundClick}>
                        구독 취소 및 <br /> 환불 요청
                    </div>
                )}
            </div>
            <ModalComponent />
        </>
    );
};

export default PurchaseHistoryItem;
